<template>
  <v-container>
    <div
      class="mt-5"
      :class="{'mx-10': $vuetify.breakpoint.lgAndUp}"
      style="border:1px solid black"
    >
      <v-tabs
        ref="tabs"
        v-model="active"
        align-with-title
        slider-color="white"
        show-arrows
      >
        <v-tab
          v-for="item in filteredTabItems"
          :key="item.name"
          class="divider font-black"
        >
          {{ item.name }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="active">
        <v-tab-item
          v-if="$hasPermissionTo(['view holidays'])"
          class="pb-12"
        >
          <setup-holiday-holiday-container-view />
        </v-tab-item>

        <v-tab-item
          v-if="$hasPermissionTo(['view holiday details'])"
          class="pb-12"
        >
          <setup-holiday-holiday-detail-container-view />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupHolidayHolidayContainerView: () => import('@/components/hris/setup/holiday/holiday/ContainerView'),
      SetupHolidayHolidayDetailContainerView: () => import('@/components/hris/setup/holiday/holiday-detail/ContainerView'),
    },
    data () {
      return {
        tabItems: [ ],
        active: null,
      }
    },

    computed: {   
      filteredTabItems () {
        let modifiedTab = [...this.tabItems]
 
        if (this.$hasPermissionTo(['view holidays'])) {
          modifiedTab.push({ name: 'Holidays' })
        }

        if (this.$hasPermissionTo(['view holiday details'])) {
          modifiedTab.push({ name: 'Holiday Details' })
        }
        
        return modifiedTab
      },
    },
  }
</script>

<style scoped>
.divider { 
  border-right: 1px solid #707070;
  border-bottom: 1px solid #707070;
} 

.font-black{
  color:black !important;
}

.divider.font-black.v-tab.v-tab--active{
  border-bottom:0px;
}

.v-tab {
  text-transform: none !important;
  max-height: 33px;
}
</style>
